import React from 'react';

/**
 * PrintingFontStyles - Shared font face declarations for printing pages
 * Include this component once at the top of each printing page
 */
const PrintingFontStyles: React.FC = () => (
  <style>{`
    /* Font utility classes (all Montserrat since the custom-font swap) */
    .hearns-font {
      font-family: 'Montserrat', sans-serif;
      font-weight: 800;
      letter-spacing: -0.02em;
    }
    .embossing-font {
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      letter-spacing: 0.15em;
    }
    .smilecake-font {
      font-family: 'Montserrat', sans-serif;
      font-weight: 800;
    }
    .neuzeit-font {
      font-family: 'Montserrat', sans-serif;
    }
    .neuzeit-light-font {
      font-family: 'Montserrat', sans-serif;
      font-weight: 300;
    }
    .neuzeit-bold-font {
      font-family: 'Montserrat', sans-serif;
      font-weight: bold;
    }
  `}</style>
);

export default PrintingFontStyles;
